<div class="filter-page" *ngIf="isOpen">
  <div class="filter-content">
    <div class="filter-panel">
      <!-- Close Button -->
      <button class="close-button" (click)="closeFilter()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 6L18 18M18 6L6 18" stroke="#888888" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      
      <!-- Location Section -->
      <div class="filter-section location-section">
      <h3 class="section-title">{{locationNameLabel}}</h3>
      <div class="search-input-container">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-icon">
          <circle cx="11" cy="11" r="7" stroke="#C5C5C5" stroke-width="2"/>
          <path d="M20 20L17 17" stroke="#C5C5C5" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <input type="text" class="search-input" [placeholder]="placeholderText" [(ngModel)]="locationQuery">
      </div>
    </div>

    <!-- Service Section with Autocomplete -->
    <div class="filter-section">
      <h3 class="section-title">{{serviceLabel}} {{getServiceSelectedCount() > 0 ? '('+ getServiceSelectedCount() +')': '' }}</h3>
      
      <!-- Autocomplete Search -->
      <div class="search-input-container">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-icon">
          <circle cx="11" cy="11" r="7" stroke="#C5C5C5" stroke-width="2"/>
          <path d="M20 20L17 17" stroke="#C5C5C5" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <input type="text" 
               class="search-input" 
               [placeholder]="placeholderText"
               [(ngModel)]="serviceSearchText"
               (ngModelChange)="filterServices($event)"
               [matAutocomplete]="serviceAuto">
        <mat-autocomplete #serviceAuto="matAutocomplete"
                          (optionSelected)="onServiceSelected($event)">
          <mat-option *ngFor="let service of (filteredServices$ | async)" 
                      [value]="service.value">
            {{service.value}}
          </mat-option>
        </mat-autocomplete>
      </div>

      <!-- Selected Services as Chips -->
      <div class="filter-chips" *ngIf="selectedServices.length > 0">
        <mat-chip-set>
          <mat-chip *ngFor="let service of selectedServices" 
                    (removed)="removeService(service)"
                    [removable]="true">
            {{service.value}}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-set>
      </div>
    </div>

    <!-- Location Type Section -->
    <div class="filter-section">
      <h3 class="section-title">{{typeLabel}} {{getLocationTypeSelectedCount() > 0 ? '('+ getLocationTypeSelectedCount() +')' : ''}}</h3>
      <div class="search-input-container">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-icon">
          <circle cx="11" cy="11" r="7" stroke="#C5C5C5" stroke-width="2"/>
          <path d="M20 20L17 17" stroke="#C5C5C5" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <input type="text" class="search-input" [placeholder]="placeholderText" [(ngModel)]="locationTypeSearchQuery">
      </div>
      <div class="options-list">
        <label *ngFor="let option of getFilteredLocationTypes()" class="option-item">
          <input type="checkbox" class="checkbox" [(ngModel)]="option.selected">
          <span class="option-label">{{option.label}}</span>
        </label>
      </div>
    </div>

    <!-- Filter Footer -->
    <div class="filter-footer">
      <button class="clear-button" (click)="clearFilters()">
        {{clearAllBtnText}}
      </button>
      <button class="apply-button" (click)="applyFilters()">
        {{applyBtnText}}
      </button>
    </div>
    </div>
  </div>
</div>
